import { Directive } from 'vue';

const autogrowHandler = (minHeight: number, maxHeight: number) => async (event: Event) => {
  const el = event.currentTarget as HTMLTextAreaElement;

  el.style.minHeight = `${minHeight}px`;
  el.style.maxHeight = `${maxHeight}px`;
  el.style.height = '0px';

  const computed = await window.getComputedStyle(el);
  const height = [
    Number.parseInt(computed.getPropertyValue('border-top-width'), 10),
    Number.parseInt(computed.getPropertyValue('padding-top'), 10),
    el.scrollHeight,
    Number.parseInt(computed.getPropertyValue('padding-bottom'), 10),
    Number.parseInt(computed.getPropertyValue('border-bottom-width'), 10),
  ].reduce((r, v) => r + v, 0);

  el.style.height = `${height}px`;
};

export const VAutogrowDirective: Directive<
  HTMLTextAreaElement,
  {
    readonly enabled: boolean;
    readonly minHeight: number;
    readonly maxHeight: number;
  }
> = {
  async beforeMount(el, binding) {
    if (!binding.value.enabled) {
      return;
    }

    const handler = autogrowHandler(binding.value.minHeight, binding.value.maxHeight);

    el.addEventListener('input', handler);

    handler({ currentTarget: el } as never as Event);
  },
  beforeUnmount(el, binding) {
    if (!binding.value.enabled) {
      return;
    }

    const handler = autogrowHandler(binding.value.minHeight, binding.value.maxHeight);

    el.removeEventListener('input', handler);
  },
};
